import { createContext, useContext, useEffect, useState } from "react";
import { addToCart, getCart, removeFromCart } from "../services/cartApi";

const CartContext = createContext();

const getSessionId = () => {
  let id = localStorage.getItem("session_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("session_id", id);
  }
  return id;
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  const loadCart = async () => {
    try {
      const sessionId = getSessionId();
      const data = await getCart(sessionId);
      setCartItems(data.items || []);
    } catch (err) {
      console.log("Cart load error:", err);
    }
  };

  useEffect(() => {
    loadCart();
  }, []);

  const handleAddToCart = async (product, qty = 1) => {
    const sessionId = getSessionId();
    await addToCart(product.id, qty, sessionId);
    await loadCart();
  };

  const handleRemove = async (productId) => {
    const sessionId = getSessionId();
    await removeFromCart(productId, sessionId);
    await loadCart();
  };

  // ✅ ONLY ADDITION
  const clearCart = () => {
    setCartItems([]);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart: handleAddToCart,
        removeItem: handleRemove,
        reloadCart: loadCart,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);